<ng-container>
  <div class="monopoint-calculate-margin__section">
    <div class="monopoint-calculate-margin__header">
      <h2>{{ 'NEW_CONTRACTS.CALCULATE_MARGIN' | i18nextEager }}</h2>
    </div>
    <div class="monopoint-calculate-margin__center">
      <form [formGroup]="enterMarginsForm">
        <div
          class="monopoint-calculate-margin__grid-col--12 monopoint-calculate-margin__gap--50"
          [ngClass]="{'monopoint-calculate-margin__pt-style': !isUserSpanish}"
        >
          <div class="monopoint-calculate-margin__col-span--12">
            <mat-form-field *ngIf="enterMarginsForm?.get('marginTP')" appearance="outline" [ngClass]="{
                'monopoint-calculate-margin__fix-label':
                  enterMarginsForm?.get('marginTP').invalid &&
                  !(
                    enterMarginsForm?.get('marginTP').touched ||
                    enterMarginsForm?.get('marginTP').dirty
                  )
              }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TP' | i18nextEager }}</mat-label>
              <input matInput formControlName="marginTP" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm.get('marginTP')" />
              <span class="monopoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.€KW_ANY' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.get('marginTP').errors?.required &&
                (enterMarginsForm?.get('marginTP').touched ||
                  enterMarginsForm?.get('marginTP').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.get('marginTP').errors?.max &&
                  (enterMarginsForm?.get('marginTP').touched ||
                    enterMarginsForm?.get('marginTP').dirty)
                ">
                {{ 'NEW_CONTRACTS.MAX_24' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="monopoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.get('marginTEP1')" appearance="outline" [ngClass]="{
              'monopoint-calculate-margin__fix-label':
                enterMarginsForm?.get('marginTEP1').invalid &&
                !(
                  enterMarginsForm?.get('marginTEP1').touched ||
                  enterMarginsForm?.get('marginTEP1').dirty
                )
            }">
              <mat-label *ngIf="isUserSpanish">{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P1' | i18nextEager }}</mat-label>
              <mat-label *ngIf="!isUserSpanish">{{ 'NEW_CONTRACTS.MARGIN_AGENTE' | i18nextEager }}</mat-label>
              <input matInput formControlName="marginTEP1" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm.get('marginTEP1')" />
              <span class="monopoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.get('marginTEP1').errors?.required &&
                (enterMarginsForm?.get('marginTEP1').touched ||
                  enterMarginsForm?.get('marginTEP1').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.get('marginTEP1').errors?.max &&
                  (enterMarginsForm?.get('marginTEP1').touched ||
                    enterMarginsForm?.get('marginTEP1').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="monopoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.get('marginTEP2')" appearance="outline" [ngClass]="{
              'monopoint-calculate-margin__fix-label':
                enterMarginsForm?.get('marginTEP2').invalid &&
                !(
                  enterMarginsForm?.get('marginTEP2').touched ||
                  enterMarginsForm?.get('marginTEP2').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P2' | i18nextEager }}</mat-label>
              <input matInput formControlName="marginTEP2" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm.get('marginTEP2')" />
              <span class="monopoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.get('marginTEP2').errors?.required &&
                (enterMarginsForm?.get('marginTEP2').touched ||
                  enterMarginsForm?.get('marginTEP2').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.get('marginTEP2').errors?.max &&
                  (enterMarginsForm?.get('marginTEP2').touched ||
                    enterMarginsForm?.get('marginTEP2').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="monopoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.get('marginTEP3')" appearance="outline" [ngClass]="{
              'monopoint-calculate-margin__fix-label':
                enterMarginsForm?.get('marginTEP3').invalid &&
                !(
                  enterMarginsForm?.get('marginTEP3').touched ||
                  enterMarginsForm?.get('marginTEP3').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P3' | i18nextEager }}</mat-label>
              <input matInput formControlName="marginTEP3" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm.get('marginTEP3')" />
              <span class="monopoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.get('marginTEP3').errors?.required &&
                (enterMarginsForm?.get('marginTEP3').touched ||
                  enterMarginsForm?.get('marginTEP3').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.get('marginTEP3').errors?.max &&
                  (enterMarginsForm?.get('marginTEP3').touched ||
                    enterMarginsForm?.get('marginTEP3').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="monopoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.get('marginTEP4')" appearance="outline" [ngClass]="{
              'monopoint-calculate-margin__fix-label':
                enterMarginsForm?.get('marginTEP4').invalid &&
                !(
                  enterMarginsForm?.get('marginTEP4').touched ||
                  enterMarginsForm?.get('marginTEP4').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P4' | i18nextEager }}</mat-label>
              <input matInput formControlName="marginTEP4" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm.get('marginTEP4')" />
              <span class="monopoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.get('marginTEP4').errors?.required &&
                (enterMarginsForm?.get('marginTEP4').touched ||
                  enterMarginsForm?.get('marginTEP4').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.get('marginTEP4').errors?.max &&
                  (enterMarginsForm?.get('marginTEP4').touched ||
                    enterMarginsForm?.get('marginTEP4').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="monopoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.get('marginTEP5')" appearance="outline" [ngClass]="{
              'monopoint-calculate-margin__fix-label':
                enterMarginsForm?.get('marginTEP5').invalid &&
                !(
                  enterMarginsForm?.get('marginTEP5').touched ||
                  enterMarginsForm?.get('marginTEP5').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P5' | i18nextEager }}</mat-label>
              <input matInput formControlName="marginTEP5" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm.get('marginTEP5')" />
              <span class="monopoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.get('marginTEP5').errors?.required &&
                (enterMarginsForm?.get('marginTEP5').touched ||
                  enterMarginsForm?.get('marginTEP5').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.get('marginTEP5').errors?.max &&
                  (enterMarginsForm?.get('marginTEP5').touched ||
                    enterMarginsForm?.get('marginTEP5').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="monopoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.get('marginTEP6')" appearance="outline" [ngClass]="{
              'monopoint-calculate-margin__fix-label':
                enterMarginsForm?.get('marginTEP6').invalid &&
                !(
                  enterMarginsForm?.get('marginTEP6').touched ||
                  enterMarginsForm?.get('marginTEP6').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P6' | i18nextEager }}</mat-label>
              <input matInput formControlName="marginTEP6" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm.get('marginTEP6')" />
              <span class="monopoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.get('marginTEP6').errors?.required &&
                (enterMarginsForm?.get('marginTEP6').touched ||
                  enterMarginsForm?.get('marginTEP6').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.get('marginTEP6').errors?.max &&
                  (enterMarginsForm?.get('marginTEP6').touched ||
                    enterMarginsForm?.get('marginTEP6').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="monopoint-calculate-margin__col-span--6 monopoint-calculate-margin__col-start--7">
            <button
              class="monopoint-calculate-margin__button-query"
              [ngClass]="{'monopoint-calculate-margin__button-query--pt': !isUserSpanish}"
              (click)="calculateMargin()"
              [disabled]="!enterMarginsForm?.valid">
              {{ 'NEW_CONTRACTS.CALCULATE' | i18nextEager }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="showCalculation">
  <div class="monopoint-calculate-margin__section">
    <div class="monopoint-calculate-margin__header--result monopoint-calculate-margin__header">
      <h2>{{ 'NEW_CONTRACTS.RESULT_SIMULATION' | i18nextEager }}</h2>
    </div>
    <div class="monopoint-calculate-margin__select-calculate-commission__result monopoint-calculate-margin__result">
      <table>
        <tr>
          <th id="price"></th>
          <th *ngIf="enterMarginsForm?.get('marginTEP1')" id="p1">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P1' | i18nextEager }}</th>
          <th *ngIf="enterMarginsForm?.get('marginTEP2')" id="p2">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P2' | i18nextEager }}</th>
          <th *ngIf="enterMarginsForm?.get('marginTEP3')" id="p3">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P3' | i18nextEager }}</th>
          <th *ngIf="enterMarginsForm?.get('marginTEP4')" id="p4">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P4' | i18nextEager }}</th>
          <th *ngIf="enterMarginsForm?.get('marginTEP5')" id="p5">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P5' | i18nextEager }}</th>
          <th *ngIf="enterMarginsForm?.get('marginTEP6')" id="p6">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P6' | i18nextEager }}</th>
        </tr>
        <tr *ngIf="resultTP.length > 0 && isUserSpanish">
          <td>
            TP<span class="units">{{ 'COMMONS.EUROS_KW_YEAR' | i18nextEager }}</span>
          </td>
          <td *ngFor="let tp of resultTP.slice(0, period); let i = index">
            {{ (fee === '2.0TD' && i >= 3 ? null : tp) | number: '1.6-6' }}
          </td>
        </tr>
        <tr *ngIf="resultTE.length > 0 && fixPrice && !passThrough && !fijoFlex">
          <td>
            TE<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let te of resultTE.slice(0, period); let i = index">
            {{ (fee === '2.0TD' && i >= 3 ? null : te) | number: '1.6-6' }}
          </td>
        </tr>
        <tr *ngIf="resultAI.length > 0 && !fixPrice && !passThrough && !fijoFlex">
          <td>
            Ai<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let ai of resultAI.slice(0, period); let i = index">
            {{
            (fee === '2.0TD' && i >= 3 ? null : ai ? ai + campaignRealTE[i] : ai)
            | number: '1.6-6'
            }}
          </td>
        </tr>
        <tr *ngIf="resultFijoFlexSimple.length > 0 && fijoFlex && !isUserSpanish && fijoFlexSimple">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.PF_REF' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let pref of resultFijoFlexSimple.slice(0, period); let i = index">
            {{ fee === '2.0TD' && i >= 3 ? null : (( pref ? pref : '' ) | number: '1.6-6') }}
          </td>
        </tr>
        <tr *ngIf="(campaignKI.length > 0 && !fixPrice && !passThrough && !fijoFlex) || (fijoFlex && !isUserSpanish && fijoFlexSimple)">
          <td>
            Ki
          </td>
          <td *ngFor="let ki of campaignKI.slice(0, period); let i = index">
            {{ (fee === '2.0TD' && i >= 3 ? null : ki) | number: '1.3-6' }}
          </td>
        </tr>
        <tr *ngIf="passThrough && isUserSpanish">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.GDOS' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let gdo of campaignGDOS.slice(0, period); let i = index">
            {{ fee === '2.0TD' && i >= 3 ? null : ((gdo / 1000) | number: '1.6-6') }}
          </td>
        </tr>
        <tr *ngIf="passThrough || (fijoFlex && !isUserSpanish && fijoFlexSimple)">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.CG' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let cg of resultCG.slice(0, period); let i = index">
            {{ fee === '2.0TD' && i >= 3 ? null : (( cg / 1000) | number: '1.6-6') }}
          </td>
        </tr>
        <tr *ngIf="passThrough && isUserSpanish">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.FI' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let fi of campaignFI.slice(0, period); let i = index">
            {{ fee === '2.0TD' && i >= 3 ? null : ((fi / 1000) | number: '1.6-6') }}
          </td>
        </tr>
        <tr *ngIf="fijoFlex && !fijoFlexSimple">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.FIXED_PRICE' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let pfijo of resultFijoFlex.slice(0, period); let i = index">
            {{ fee === '2.0TD' && i >= 3 ? null : (( pfijo ? pfijo : '' ) | number: '1.6-6') }}
          </td>
        </tr>
        <tr *ngIf="fijoFlex && isUserSpanish">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.S_ADJUST' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let pfijo of campaignPFijo.slice(0, period); let i = index">
            {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.INDEX' | i18nextEager }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</ng-container>
